module.exports = __webpack_public_path__ + "img/logo-taff-120.b223e578.svg";